export default __webpack_public_path__ + "assets/models/b66c2a7fa02a4d30eafeff4366961069.glb";